var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52,
    x2: 52,
    y1: 64,
    y2: 40,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#155cde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#2289e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#289fec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 53.5,
    x2: 53.5,
    y1: 46,
    y2: 57,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f6f6f"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M0 171.997V0h171.997v171.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.813 138.938v-85.5h135.375v85.5c0 7.87-6.38 14.25-14.25 14.25H32.063c-7.87 0-14.25-6.38-14.25-14.25",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#bbdefb",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.188 39.188v21.374H17.813V39.189c0-7.87 6.38-14.25 14.25-14.25h106.874c7.87 0 14.25 6.38 14.25 14.25",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#2196f3",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 39.188c0 5.899-4.784 10.687-10.688 10.687-5.903 0-10.687-4.788-10.687-10.688 0-5.899 4.784-10.687 10.688-10.687 5.903 0 10.687 4.788 10.687 10.688m-64.125 0c0 5.899-4.784 10.687-10.688 10.687-5.903 0-10.687-4.788-10.687-10.688 0-5.899 4.784-10.687 10.688-10.687 5.903 0 10.687 4.788 10.687 10.688",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#1565c0",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.563 14.25a7.128 7.128 0 0 0-7.126 7.125v17.813a7.125 7.125 0 0 0 14.25 0V21.375a7.132 7.132 0 0 0-7.124-7.125m-64.126 0a7.128 7.128 0 0 0-7.124 7.125v17.813a7.125 7.125 0 0 0 14.25 0V21.375a7.132 7.132 0 0 0-7.126-7.125",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b0bec5",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M52 42a10 10 0 1 0 0 20 10 10 0 1 0 0-20z",
    transform: "translate(.333 .333) scale(2.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    d: "M52 40c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16z",
    transform: "translate(.333 .333) scale(2.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "m56.707 55.293-2.781-2.781c.043-.165.074-.334.074-.512 0-.738-.405-1.376-1-1.723V47a1 1 0 1 0-2 0v3.277c-.595.346-1 .984-1 1.723a2 2 0 0 0 2 2c.178 0 .347-.031.512-.074l2.781 2.781a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z",
    transform: "translate(.333 .333) scale(2.66667)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTime);
export default __webpack_public_path__ + "static/media/scheduleTime.b1dc08c46f5130077d29b001ab7ff614.svg";
export { ForwardRef as ReactComponent };